<template>
  <aside
    :class="sidebarClasses"
    class="relative flex flex-col"
    style="overflow-x: visible; overflow-y: hidden;"
  >
    <!-- Expanded content -->
    <div
      v-show="!collapsed"
      class="flex flex-col h-full"
    >
      <div class="flex h-full flex-col p-3">
        <!-- User Info Section -->
        <div class="bg-white pb-9 pt-6 shadow rounded-lg mb-3">
          <img
            src="@/assets/perbyte_logo.png"
            alt="User avatar"
            class="mx-auto rounded-full shadow-md w-24 h-24 mb-2"
          >
          <div class="text-center mt-5">
            <p class="text-lg font-semibold">
              {{ userName }}
            </p>
            <p>
              <a
                href="#"
                class="mx-2 hover:text-gray-500"
              >
                {{ email }}
              </a>
            </p>
          </div>
        </div>

        <!-- Slot for additional sidebar content -->
        <div class="flex-1 overflow-auto mb-3">
          <slot />
        </div>
      </div>
    </div>

    <!-- Collapse/Expand Button: vertical bar position -->
    <div class="absolute right-0 top-1/2 z-10 -translate-y-1/2 overflow-hidden w-6">
      <button
        :class="toggleButtonClasses"
        @click="toggle"
      >
        <component
          :is="collapsed ? ChevronRightIcon : ChevronLeftIcon"
          class="w-6 h-6 mr-3 text-gray-600"
        />
      </button>
    </div>
  </aside>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useDsaReportsStore } from '@/pinia/dsaReportsStore';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-vue-next';

// Fetch user data
const myStore = useDsaReportsStore();
onMounted(() => { myStore.fetchUserData(); });
const userName = computed(() => myStore.userName);
const email = computed(() => myStore.email);
const props = defineProps({
  heightClass: {
    type: String,
    default: 'h-screen'
  }
});

// Collapse state
const collapsed = ref(false);
const toggle = () => { collapsed.value = !collapsed.value; };

// Sidebar width transition
const sidebarClasses = computed(() => [
  'flex-none shrink-0 bg-gray-100 shadow-md transition-width duration-200',
  props.heightClass,
  collapsed.value
    ? 'w-8 min-w-8 max-w-8 basis-8'
    : 'w-80 min-w-80 max-w-80 basis-80'
].join(' '));

// Toggle button position & style
const toggleButtonClasses = computed(() => [
  'relative',
  '-left-2',
  'bg-white',
  'rounded-full',
  'p-1',
  'shadow',
  'hover:bg-gray-200'
].join(' '));
</script>

<style scoped>
/* Smooth width transition */
.transition-width {
  transition-property: width;
}

aside {
  min-height: 0;
}
</style>
